import {
  createBreadcrumbStructuredData,
  createFaqStructuredData,
} from "~/lib/shared/meta";

type JsonLdScript = { type: "application/ld+json"; children: string };

type Props = {
  /** Breadcrumb trail from "Home" to the page itself. */
  breadcrumbs: ReadonlyArray<{ name: string; url: string }>;
  /** The page's FAQ items; a FAQPage graph is added only when there are some. */
  faqItems?: ReadonlyArray<{ question: string; answer: string }> | null;
  /** A CollectionPage graph that precedes the breadcrumb, when the page has one. */
  collectionPage?: Record<string, unknown>;
};

/**
 * The JSON-LD `<script>` entries of a public coach listing's `head`, in the
 * order search engines have seen them: collection page, breadcrumb, FAQ.
 */
export function coachListJsonLdScripts({
  breadcrumbs,
  faqItems,
  collectionPage,
}: Props): JsonLdScript[] {
  const graphs = [
    ...(collectionPage ? [collectionPage] : []),
    createBreadcrumbStructuredData(breadcrumbs),
    ...(faqItems && faqItems.length > 0
      ? [createFaqStructuredData(faqItems)]
      : []),
  ];
  return graphs.map((graph) => ({
    type: "application/ld+json",
    children: JSON.stringify(graph),
  }));
}
